<template lang="pug">
  .wrapper-approvals-list
    .title gestão de aprovação
    .wrapper-approvals-header
      PSelect(v-model="kind" name="kind" labelItem="name" :allowEmpty="false" title="tipo")

      PSelect(v-model="mode" name="mode" labelItem="name" :allowEmpty="false" title="status")

      .items-slider
        RadioSlider(
          :items="categories.items"
          :current="categories.items.findIndex(i => i.id === categories.selected.id)"
          @selected="openItemsSelector"
        )

      .items-selector
        PMultiSelect(
          ref="itemSelector"
          labelItem="name"
          :title="categorieSelected.name"
          :forcedPlaceholder="forcedPlaceholder"
          :useState="categorieSelected.useState"
          :useCommon="categorieSelected.common"
          :disabled="!categories.selected"
        )

      .dates
        PDatePicker(name="startDate" label="data inicial" v-model="startDate" format="DD/MM/YY")
        PDatePicker(name="endDate" label="data final" v-model="endDate" format="DD/MM/YY")

      .consult
        PButton(color="success" size="md" @click="fetchApprovalData()" block :disabled="!validoParaPesquisar")
          | buscar

    .wrapper-approvals-sub-header(v-if="tableData.loaded ")
      .date-period
        label.date {{ formatDate(this.startDate) }} - {{ formatDate(this.endDate) }}

      .approvals-buttons-container
        Flipper(:currentView="approveShow.show ? 1 : 0")
            template(v-slot:front)
              .approve-buttons
                PButton(
                  v-if="validForVerify"
                  color="primary"
                  size="md"
                  @click="genApprovalReport"
                  block :disabled="loadingReport"
                ) gerar relatório
                span(v-else)
                PButton(:disabled="naoPossuiAprovacoesPendentes" color="danger" size="md" @click="mostrarCampoDeComentarioDoAprovar('reprove')" block) reprovar todos
                PButton(:disabled="naoPossuiAprovacoesPendentes" color="info" size="md" @click="mostrarCampoDeComentarioDoAprovar('approve')" block) aprovar todos
            template(v-slot:back)
              .approve-form
                PTextField(:disabled="naoPossuiAprovacoesPendentes" v-model="approveShow.comment" label="motivo" name="motivo")
                PButton(:disabled="naoPossuiAprovacoesPendentes" color="danger" size="md" @click="ocultarCampoDeComentarioDoAprovar" block) cancelar
                PButton(:disabled="naoPossuiAprovacoesPendentes" color="success" size="md" @click="approveAll" block) salvar

    SmartTable.table(name="approvals-list" v-bind="table", v-model="tableData" @rowClick="onSelectedApproval" ref="table")
      template(v-slot:default="slotProps")
        TableRow(v-bind="slotProps")
          template(v-slot:approved="{ columnValue, rowItem, index }")
            template(v-if="!reloadingApprovalInfo")
              Status(:item="rowItem")
            .loading-field(v-else key="loading-phoneclockPassword")

          template(v-slot:info="{ columnValue, rowItem, index }")
            template(v-if="!reloadingApprovalInfo && rowItem.typeView !== 'Apontamento'")
              span.text-container {{ parseInfo(rowItem) }}
            template(v-if="!reloadingApprovalInfo && rowItem.typeView === 'Apontamento' && Object.keys(rowItem.info.apontamentos).length > 1")
              span.text-container Vários apontamentos
            template(v-if="!reloadingApprovalInfo && rowItem.typeView === 'Apontamento' && Object.keys(rowItem.info.apontamentos).length < 2")
              TimeMeasurements(:line="rowItem.info")
            .loading-field(v-else key="loading-phoneclockPassword")

          template(v-slot:employeeReason="{ columnValue, rowItem, index }")
            template(v-if="!reloadingApprovalInfo") {{ parseEmployeeReason(rowItem)  }}
            .loading-field(v-else key="loading-phoneclockPassword")

      template(v-slot:detailsBox="{item}")
        ApprovalDetails(
          :approval="approvalInfoPerId[item.id]"
          :loading="loadingSelectedApprovalInfo"
          @updateTable="updateTable"
        )
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

import { formatDateToSend } from 'src/utils'
import RadioSlider from 'src/common/Tabs/RadioSlider'
import Flipper from 'src/common/transitions/Flipper'

import TimeMeasurements from './ApprovalsComponents/ApprovalsTms'
import Status from './ApprovalsComponents/ApprovalStatus.vue'
import ApprovalDetails from './ApprovalDetails'
import { pegarMensagemDoProblemaTooltip } from './utils.js'

export default {
  name: 'ApprovalsList',
  created () {
    this.categories.selected = this.categories.items[1]
  },
  data () {
    return {
      mode: {
        loaded: [
          {id: 'all', name: 'todos'},
          {id: 'pending', name: 'pendentes'},
          {id: 'approved', name: 'aprovados'},
          {id: 'reproved', name: 'reprovados'}
        ],
        selected: {id: 'pending', name: 'pendentes'}
      },
      kind: {
        loaded: [
          {id: 'all', name: 'todos'},
          {id: 'line', name: 'apontamentos'},
          {id: 'fktls', name: 'correção de pontos'},
          {id: 'just', name: 'dispensa'}
        ],
        selected: {id: 'all', name: 'todos'}
      },
      categories: {
        selected: null,
        items: [
          { name: 'locais', id: 'companies', alias: 'work-place', common: 'companies/onlyActive', useState: 'verifyTimesheet/companies' },
          { name: this.$wp('employee'), id: 'employees', alias: 'employee', common: 'employees/onlyNotFired', useState: 'verifyTimesheet/employees' },
          { name: 'grupos', id: 'userGroups', alias: 'user-group', common: 'userGroups', useState: 'verifyTimesheet/userGroups' }
        ]
      },
      selectedApprovals: { index: null, item: null },
      allApprovals: [],
      loadingReport: false,
      pesquisaCarregando: false,
      reloadingApprovalInfo: false,
      forceReloadInfo: false,
      approveShow: { show: false, kind: '', comment: '' },
      approvalInfoPerId: {},
      table: {
        headerItems: [
          {column: 'status', field: 'approved', width: '0.2fr'},
          {column: 'data', field: 'date', width: '0.2fr'},
          {column: this.$ws('employee'), field: 'employeeName', width: '0.5fr'},
          {column: 'evento', field: 'typeView', width: '0.3fr'},
          {column: 'informação', field: 'info', width: '0.4fr'},
          {column: 'motivo do evento', field: 'employeeReason', width: '0.3fr'},
          {column: 'aprovador por', field: 'approvedBy', width: '0.4fr'}
        ],
        config: {
          perPage: 13,
          startFocusedSearch: 'employeeName',
          defaultSortField: 'employeeName',
          defaultColumnSearch: 'employeeName'
        }
      }
    }
  },
  computed: {
    ...mapState('verifyTimesheet', ['startDate', 'endDate', 'employees', 'companies', 'userGroups']),
    tableData: {
      get () {
        return {
          loading: this.pesquisaCarregando,
          loaded: this.allApprovals
        }
      },
      set ({selected}) {
        this.selectedApprovals = selected
      }
    },
    categorieSelected () {
      if (this.categories.selected) return this.categories.selected

      return {
        name: 'Selecionar',
        id: 'employees',
        alias: 'employee',
        common: 'employees/onlyNotFired',
        useState: 'verifyTimesheet/employees'
      }
    },
    startDate: {
      get () {
        return this.$store.state.verifyTimesheet.startDate
      },
      set (value) {
        this.$store.commit('verifyTimesheet/startDate', value)
      }
    },
    endDate: {
      get () {
        return this.$store.state.verifyTimesheet.endDate
      },
      set (value) {
        this.$store.commit('verifyTimesheet/endDate', value)
      }
    },
    forcedPlaceholder () {
      const companies = this.companies.selected
      const employees = this.employees.selected
      const userGroups = this.userGroups.selected

      if (companies.length || employees.length || userGroups.length) {
        return null
      }

      if (this.categories.selected.id === 'companies') {
        return 'selecionar locais'
      } else if (this.categories.selected.id === 'employees') {
        return `selecionar ${this.$wp('employee')}`
      } else {
        return 'selecionar grupos'
      }
    },
    lastChanged () {
      return this.categories.selected.alias
    },
    validForVerify () {
      if (!this.employees.selected.length && !this.companies.selected.length && !this.userGroups.selected.length) {
        return false
      }
      return true
    },
    validoParaPesquisar () {
      return moment(this.startDate).isValid() && moment(this.endDate).isValid()
    },
    naoPossuiAprovacoesPendentes () {
      const aprovacoes = this.allApprovals
      if (aprovacoes && Array.isArray(aprovacoes) && aprovacoes.length > 0) {
        const possuiAprovacoesPendentes = aprovacoes.some(aprovacao => aprovacao.approved === null)
        return !possuiAprovacoesPendentes
      }
      return true
    }
  },
  mounted () {
    this.updateTable()
  },
  methods: {
    async genApprovalReport () {
      const QUERY_KIND = {
        'companies': 'company',
        'employees': 'employee',
        'userGroups': 'user_group'
      }

      this.loadingReport = true

      try {
        const params = {
          queryKind: QUERY_KIND[this.categories.selected.id],
          idList: this[this.categories.selected.id].selected.map(i => i.id),
          startDate: formatDateToSend(this.startDate),
          endDate: formatDateToSend(this.endDate)
        }

        const result = await this.$API.approvalsReport.save(params)
        if (result.body.success) {
          this.$modalDeSucesso(result.body.success)
        }
        this.$checkUserFiles()
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingReport = false
      }
    },
    formatDate (date) {
      const momentDate = moment(date)
      if (!momentDate.isValid()) return 'Data inválida'
      return momentDate.format('DD.MM.YYYY')
    },
    formatHour (hour) {
      return moment(hour).format('HH:mm')
    },
    openItemsSelector (item) {
      this.categories.selected = item
      this.$refs.itemSelector.open()
    },
    async updateTable (reloadAllApproval = false) {
      this.reloadingApprovalInfo = true

      this.closeDetailsTable()
      this.fetchApprovalData()

      this.reloadingApprovalInfo = false

      this.forceReloadInfo = reloadAllApproval === true
    },
    async fetchApprovalData () {
      const QUERY_KIND = {
        'companies': 'company',
        'employees': 'employee',
        'userGroups': 'user_group'
      }

      this.pesquisaCarregando = true

      try {
        const params = {
          queryKind: QUERY_KIND[this.categories.selected.id],
          idList: this[this.categories.selected.id].selected.map(i => i.id),
          modelKind: this.kind.selected.id,
          approveKind: this.mode.selected.id,
          startDate: formatDateToSend(this.startDate),
          endDate: formatDateToSend(this.endDate)
        }

        const result = await this.$API.approvals.save(params)
        this.allApprovals = result.body.success.map(item => {
          return {
            ...item,
            observacao: pegarMensagemDoProblemaTooltip(item)
          }
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.pesquisaCarregando = false
      }
    },
    closeDetailsTable () {
      this.$refs.table.closeDetailsBox()
    },
    async onSelectedApproval (approval) {
      if (!this.approvalInfoPerId[approval.id] || this.forceReloadInfo) {
        this.$set(this.approvalInfoPerId, approval.id, {...approval})
        this.loadingSelectedApprovalInfo = true

        const completeInfo = await this.$API.approvals.save({
          approvalId: approval.id,
          typeView: approval.typeView
        })

        this.$set(this.approvalInfoPerId, approval.id, completeInfo.body.success[0])
        this.loadingSelectedApprovalInfo = false
        this.forceReloadInfo = false
      }
    },
    parseInfo (item) {
      if (item.typeView === 'Correção de ponto') {
        return item.info.kind + ' às ' + item.info.time
      } else if (item.typeView === 'Dispensa') {
        if (item.info.allDay) {
          return 'Dispensa para o dia inteiro'
        } else {
          if (item.info.startTime) {
            return 'Disp. parcial das ' + this.formatHour(item.info.startTime) + ' às ' + this.formatHour(item.info.endTime)
          } else if (item.info.duration) {
            return 'Disp. parcial com ' + item.info.duration + ' horas de duração'
          } else {
            return 'Dispensa parcial'
          }
        }
      } else if (item.typeView === 'Apontamento') {
        return item.info.apontamentos
      } else {
        return ''
      }
    },
    parseEmployeeReason (item) {
      if (!item.employeeReason) {
        if (item.typeView === 'Correção de ponto') {
          return item.info.justificativa
        } else {
          return '-'
        }
      } else {
        return item.employeeReason
      }
    },
    parseStatus (item) {
      if (item.approved === true) return 'aprovado'
      else if (item.approved === false) return 'reprovado'
      else return 'pendente'
    },
    async approveAll () {
      const ehOperacaoDeReprovacao = this.approveShow.kind === 'reprove'
      const comentarioEstaVazio = this.approveShow.comment === ''
      if (ehOperacaoDeReprovacao && comentarioEstaVazio) {
        this.$modalDeErro('É preciso informar um motivo para reprovar um evento')
        return
      }

      const params = {
        approvsIds: this.tableData.loaded.map((item) => item.id),
        approved: this.approveShow.kind === 'approve',
        approvalComment: this.approveShow.comment
      }

      try {
        const respostaDaRequisicao = await this.$API.approveLines.save(params)
        if ('success' in respostaDaRequisicao.body) {
          this.$modalDeSucesso('success' in respostaDaRequisicao.body ? respostaDaRequisicao.body.success : 'Operação realizada com sucesso')
        }
      } catch (erro) {
        this.$modalDeErro('error' in erro.body ? erro.body.error : 'Aconteceu um erro inesperado. Tente novamente ou entre em contato com o suporte')
      } finally {
        this.ocultarCampoDeComentarioDoAprovar()
        this.updateTable(true)
      }
    },
    ocultarCampoDeComentarioDoAprovar () {
      this.approveShow = {show: false, kind: '', comment: ''}
    },
    mostrarCampoDeComentarioDoAprovar (tipoDeOperacao) {
      this.approveShow = {show: true, kind: tipoDeOperacao, comment: ''}
    }
  },
  components: { RadioSlider, TimeMeasurements, Status, ApprovalDetails, Flipper }
}
</script>

<style scoped lang="scss">

.wrapper-approvals-list {
  display: grid;
  grid-template-rows: min-content min-content auto;
  grid-template-columns: 1fr;

  .title{
    grid-row: 1;
    font-size: 27px;
    font-weight: 400;
    text-align: center;
    justify-items: center;
    margin: 10px 0;
  }

  .sheet {
    width: 100%;
    height: 100%;
    text-align: center;
    grid-row: 3;
    padding-bottom: 10px;
  }
}
.selectors {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 10px;
}

.wrapper-approvals-header {
  display: grid;
  grid-template-columns: 0.3fr 0.3fr 0.6fr 0.4fr 0.5fr 0.2fr;
  grid-column-gap: 2%;
  grid-template-rows: auto;
  align-items: center;

  .items-slider {
    align-self: center;
  }

  .dates {
    display: grid;
    grid-column-gap: 3%;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
  }
}

.wrapper-approvals-sub-header {
  display: grid;
  grid-template-columns: 0.3fr 0.3fr 1fr;
  grid-column-gap: 2%;
  grid-template-rows: 50px;
  align-items: flex-end;
  margin-top: 30px;
  margin-bottom: 1%;

  .approvals-buttons-container {
    height: 100%;

    .approve-buttons {
      display: grid;
      height: 100%;
      grid-template-columns: 0.5fr 0.5fr 0.5fr;
      grid-column-gap: 5px;
      justify-self: right;
      grid-column: 3/3;
    }

    .approve-form {
      display: grid;
      height: 100%;
      grid-template-columns: 0.5fr 0.3fr 0.3fr;
      grid-column-gap: 5px;
      justify-self: right;
      grid-column: 3/3;
    }

  }

  .date-period {
    grid-column: 1/3;
    justify-self: left;
  }

  .date {
    color: var(--color-primary);
    font-size: 24px;
  }
}

.text-container {
  padding: 6px;
}

</style>
